const styles = {
  buttonStyle: {
    position: "absolute",
    borderRadius: "100px",
    zIndex: 3,
    border: "1px solid white",
    color: "#2f2e41",
    cursor: "pointer",
  },
  coverStyle: {
    position: "absolute",
    width: "100%",
    height: "100%",
    backdropFilter: "blur(3px)",
    zIndex: 2,
    cursor: "pointer",
  },
};

export default styles;
